document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-thumb-target]');
  if (trigger) {
    const target = document.querySelector(trigger.getAttribute('data-thumb-target'));
    const img = trigger.querySelector('img');
    if (target && img) {
      target.src = img.dataset.full || img.src;
      target.srcset = img.dataset.fullset || '';
      target.alt = img.alt || '';
    }
    return;
  }

  if (event.target.closest('[data-popup-close]')) {
    dismissPopup();
    return;
  }

  const prev = event.target.closest('[data-carousel-prev]');
  const next = event.target.closest('[data-carousel-next]');
  if (prev || next) {
    const targetId = (prev || next).getAttribute(prev ? 'data-carousel-prev' : 'data-carousel-next');
    const scroller = document.getElementById(targetId);
    if (!scroller) return;
    const firstCard = scroller.querySelector('.product-carousel__item');
    const gap = 18;
    const step = firstCard ? firstCard.getBoundingClientRect().width + gap : scroller.clientWidth * 0.9;
    scroller.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
  }
});

const popupRoot = document.querySelector('[data-popup-root]');
const popupStorageKey = 'apex_discount_popup_closed';

function dismissPopup() {
  if (!popupRoot) return;
  popupRoot.setAttribute('hidden', 'hidden');
  try {
    localStorage.setItem(popupStorageKey, '1');
  } catch (e) {}
}

function showPopup() {
  if (!popupRoot) return;
  try {
    if (localStorage.getItem(popupStorageKey) === '1') return;
  } catch (e) {}

  window.setTimeout(function () {
    popupRoot.removeAttribute('hidden');
  }, 1400);
}

window.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') dismissPopup();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', showPopup);
} else {
  showPopup();
}
